var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "helpful-actions-cell-wrapper",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("div", { staticClass: "top-section" }, [
        _c("div", { staticStyle: { "margin-right": "16px" } }, [
          _c("img", {
            staticStyle: { height: "48px", width: "48px" },
            attrs: { src: _vm.getIconURL }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "desc-styling" }, [
          _vm._v(_vm._s(_vm.description))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "link-text-styling" }, [
        _vm._v(_vm._s(_vm.linkText) + " >")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }